import React from 'react';
import './OurAdvantageSection.css';
import greenBullet from '../../assets/images/green-bullet.svg';
import advantageImage from '../../assets/images/advantage.jpg';

const OurAdvantageSection = () => {
  const advantages = [
    {
      title: 'Digital-first focus',
      description: 'Digital is in our DNA. BayPine is uniquely focused on driving value through innovation. We work to design and execute a company-wide digital transformation of the business and harness the power of data to inform decisions and pinpoint key opportunities to evolve business processes.'
    },
    {
      title: 'Discerning team',
      description: 'Our purpose-built team possesses what we believe to be a unique combination of operating experience in technology with investing experience in core sectors of the economy.'
    },
    {
      title: 'Durable relationships',
      description: 'We seek to decouple success from speed. We are not afraid to be patient and invest behind long-term value creation initiatives for the benefit of our companies and investors.'
    }
  ];

  return (
    <section className="our-advantage-section">
        <div className="advantage-header">
          <h2 className="section-label">
            <img src={greenBullet} alt="" className="bullet-image" />
            OUR ADVANTAGE
          </h2>
        </div>
        
        <div className="advantage-content">
          <div className="advantage-text">
            {advantages.map((advantage, index) => (
              <div className="advantage-item" key={index}>
                <h3 className="advantage-title">{advantage.title}</h3>
                <p className="advantage-description">{advantage.description}</p>
              </div>
            ))}
          </div>
          
          <div className="advantage-image">
            <img src={advantageImage} alt="Our Advantage" />
          </div>
        </div>
    </section>
  );
};

export default OurAdvantageSection;